import Panzoom from '@panzoom/panzoom';

class ZoomImg {
    constructor(item) {
		this.item = item;
		this.options = {
			minScale: 0.5,
			maxScale: 5,
			contain: 'outside'
		};
	}

    init() {
        this.initZoomImg()
        this.initModal()
    }

    initZoomImg() {
        if (this.item) {
			const zoomImg = this.item.querySelector('.zoom-img__img img');
			const zommContainer = zoomImg.parentElement;
			const zoomInButton = this.item.querySelector('.zoom-img__btn--in');
			const zoomOutButton = this.item.querySelector('.zoom-img__btn--out');
			const panzoom = Panzoom(zoomImg, this.options); // eslint-disable-line

            zommContainer.addEventListener('wheel', panzoom.zoomWithWheel);
			zoomInButton.addEventListener('click', panzoom.zoomIn);
			zoomOutButton.addEventListener('click', panzoom.zoomOut);

            return panzoom;
		}
	}

    initModal() {
        let _this = this;
        $('.modal-with-zoom').fancybox({
            prevEffect  : 'none',
            helpers : {
                title : {
                    type : 'inside'
                },
                overlay: {
                    locked: false
                },
                thumbs  : {
                    width : 50,
                    height  : 50
                }
            },
            tpl: {
                error    : '<p class="fancybox-error">Запрошенное изображение недоступно, повторите позже.</p>',
                closeBtn : '<a title="Закрыть" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                next     : '<a title="Следующая" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                prev     : '<a title="Предыдущая" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
            },
            "afterShow": function(instance, current){
                zoomImg();
            },
        });
    }
}

function zoomImg () {
    const containers = Array.from(document.querySelectorAll('.zoom-img'));
    if (containers.length) {
    	containers.forEach((item, index) => {
    		const zoomImg = new ZoomImg(item);
    		zoomImg.init();
    	});
    }
}

$( document ).ready(function() {
    zoomImg();
})



// WEBPACK FOOTER //
// ./frontend/components/zoom-img/zoom-img.js